import {
  galleryErrorHandler,
  photoErrorHandler,
  logoErrorHandler,
  sectionBgErrorHandler,
  slideBgErrorHandler,
} from './ErrorHandlers';

const imageErrorHandler = () => {
  galleryErrorHandler();
  photoErrorHandler();
  logoErrorHandler();
  sectionBgErrorHandler();
  slideBgErrorHandler();
};

export default imageErrorHandler;
